import { gql } from "@apollo/client";

export const updateLibraryVideo = gql`
  mutation updateLibraryVideo($_id: MongoID!, $record: UpdateByIdLibraryVideoInput!) {
    libraryVideo_UpdateById(_id :$_id, record: $record) {
      record {
        _id
      }
    }
  }
`;